/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'single',
    profile: {
        locale: 'de',
        currency: 'EUR',

        p_name_col_name: 'Name',

        p_description_col_name: 'Description',

        allowIncompleteTaxonomy: true,
        initialGroupBySupplierInactive: true, // Temporary for sample, needs to be reverted for full delivery (CAT-2838)

        taxonomyBuilderViewOnly: true,

        ppvConfigEnabledColumns: [
            'part',
            'supplier',
            'business_unit',
        ],

        showCards: [
            'contract-explorer'
        ],
        disabledCards: [
            'koi-ppv',
            'koi-spend-concentration',
            'golden-record',
        ],
        hideCards: [
            'koi-spend-concentration',
        ],

        disableCommonSuppliersAdvDashboard: true, // For compass these switches didn't do anything
        disableCommonCategoryAdvDashboard: true, // For compass these switches didn't do anything

        enableProcChat: true,
        enableGoldenRecord: true,
    },
}
